<template>
  <div calss="astarPlan">
    <div class="oneCon">
      <img src="../assets/banner4.png" alt="">
    </div>
    <div class="twoCon">
      <div class="widthCon">
        <div class="firstBox">
        <div class="left">
          <div class="title">项目背景</div>
          <div class="content">随着我国经济的快速发展，市场竞争日益激烈，生产企业需要寻求新的发展模式以提高品牌影响力和市场份额。与此同时，消费者对优质商品和服务的需求不断增长，而市场上假冒伪劣商品泛滥，严重影响了消费者的购物体验。为了解决这一问题，上海萃达科技有限公司提出了A星计划，旨在通过共享品牌、共享渠道、共享市场，形成一种新的经济生态，为生产企业、消费者以及整个经济领域带来共赢。</div>
        </div>
        <img src="../assets/star1.png" class="right" alt="">
      </div>
      <div class="secondBox">
        <div class="title">项目介绍</div>
        <div class="content">A星计划未来将重构电商规则，打造一个可持续的可验证的阳光下的诚信机制。我们将带领上百家优秀品牌公司，发展数万家生产企业和服务企业，构建新的经济模式和生态体系，让企业能够在阳光下合法开心挣钱，让消费者能够买到货真价实质优的商品。</div>
      </div>
      <div class="thirdBox">
        <div class="list">
          <div class="sign">品牌</div>
          <div class="content">A星集团公司和优秀企业共同持有品牌公司股权，共同做业界标杆品牌。</div>
        </div>
        <div class="list">
          <div class="sign">合伙人</div>
          <div class="content">A星计划中的重要组成部分，推荐和发展优秀企业。</div>
        </div>
        <div class="list">
          <div class="sign">企业</div>
          <div class="content">A星计划严选的生产企业和服务企业，共享品牌、共享渠道、共享市场。</div>
        </div>
        <div class="list">
          <div class="sign">店铺</div>
          <div class="content">A星计划专用电商平台“星元单”签约商家，低投入高回报，省心又开心。</div>
        </div>
      </div>
      <div class="fourBox">
        <img class="jtImg" src="../assets/jt.png" alt="">
        <div class="content">
          <div class="left">
            <div class="title">消费者</div>
            <div class="text">消费者通过A星计划专用电商平台“星元单”购买到货真价实、品质卓越的商品和服务。</div>
          </div>
          <div class="right">
            <img src="../assets/qrcode5.png" alt="">
            <p>扫码下载“星元单”APP</p>
          </div>
        </div>
      </div>
      </div>
    </div>
    <div class="threeCon">
      <div class="widthCon">
        <div class="left">
        <div class="title">招募计划</div>
        <div class="content">A星计划已设立上百家品牌公司，预计授权生产企业近十万家，年产值预计超过十万亿元。此外，A星计划还将发展超十万家线下服务商和数千家品牌实体店，进一步完善属于A星计划的经济生态圈。</div>
      </div>
      <div class="right">
        <div class="detailBtn" @click="gotoPage('joinUs')">
          申请加入A星计划
          <img src="../assets/btnIcon.png" alt="">
        </div>
        <div class="tip">
          <img src="../assets/toolTip.png" alt="">
          <span>首批入驻有优惠</span>
        </div>
      </div>
      </div>
    </div>
    <div class="fourCon">
      <partner-list />
    </div>
    <div class="fiveCon">
      <div class="widthCon">
        <div class="title">社会责任与经济效益</div>
      <el-row class="content" :gutter="45">
        <el-col :span="8">
          <div class="list">
            <div class="col_title">
              <div><img src="../assets/leftIcon.png" alt="">增加税收</div>
            </div>
            <div class="col_content">A星计划将带动当地经济的快速增长，提高企业的营业额和利润，增加政府税收</div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="list">
            <div class="col_title">
              <div><img src="../assets/leftIcon.png" alt="">促进就业</div>
            </div>
            <div class="col_content">A星计划将吸引大量企业入驻，带来大量的外来人口和就业机会</div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="list">
            <div class="col_title">
              <div><img src="../assets/leftIcon.png" alt="">推动产业升级</div>
            </div>
            <div class="col_content">A星计划可以促使当地产业向更高端、更具竞争力的方向发展</div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="list">
            <div class="col_title">
              <div><img src="../assets/leftIcon.png" alt="">优化经济结构</div>
            </div>
            <div class="col_content">A星计划可以引导企业走向正规化、品牌化发展道路，促进当地产业结构的优化</div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="list">
            <div class="col_title">
              <div><img src="../assets/leftIcon.png" alt="">完善产业链</div>
            </div>
            <div class="col_content">A星计划的成功将带动上下游产业链的发展，形成产业集聚效应</div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="list">
            <div class="col_title">
              <div><img src="../assets/leftIcon.png" alt="">提升地区形象</div>
            </div>
            <div class="col_content">A星计划将提升当地城市的知名度，有助于吸引更多的投资，促进当地经济发展</div>
          </div>
        </el-col>
      </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import partnerList from '@/components/partnerList.vue'
export default {
  components: {
    partnerList: partnerList
  },
  mounted() {
    document.title = "A星计划";
  },
  methods: {
    gotoPage(page) {
      this.$router.push({ path: '/' + page });
    }
  }
}
</script>

<style lang="less" scoped>
.oneCon{
  position: relative;
  img{
    width: 100%;
  }
}
.twoCon{
  padding: 74px 0px 50px 0px;
  background: #E7F6FC;
  .widthCon{
    width: 1200px;
    margin: 0 auto;
  }
  .firstBox{
    display: flex;
    .left{
      margin-right: 15px;
      .title{
        font-family: Source Han Sans;
        font-size: 30px;
        font-weight: bold;
        line-height: 48px;
        letter-spacing: normal;
        color: #222222;
      }
      .content{
        font-family: Source Han Sans;
        font-size: 20px;
        font-weight: 350;
        line-height: 34px;
        letter-spacing: normal;
        color: #666666;
        margin-top: 15px;
        text-indent: 2em;
text-align: justify;
      }
    }
    .right{
      width: 475px;
      border-radius: 10px;
    }
  }
  .secondBox{
    margin-top: 52px;
    .title{
      font-family: Source Han Sans;
      font-size: 30px;
      font-weight: bold;
      line-height: 48px;
      letter-spacing: normal;
      color: #222222;
    }
    .content{
      font-family: Source Han Sans;
      font-size: 20px;
      font-weight: 350;
      line-height: 34px;
      letter-spacing: normal;
      color: #666666;
      margin-top: 15px;
      text-indent: 2em;
text-align: justify;
    }
  }
  .thirdBox{
    margin-top: 102px;
    display: flex;
    justify-content: space-between;
    .list{
      border-radius: 10px;
      background: #FFFFFF;
      width: 246px;
      height: 190px;
      padding: 78px 23.5px 33px 23.5px;
      box-sizing: border-box;
      position: relative;
      .sign{
        position: absolute;
        width: 100px;
        height: 100px;
        line-height: 100px;
        background: #4A90E2;
        border-radius: 50%;
        font-family: Source Han Sans;
        font-size: 20px;
        font-weight: bold;
        text-align: center;
        letter-spacing: normal;
        color: #FFFFFF;
        top: -50px;
        left: calc(50% - 50px);
      }
      .content{
        font-family: Source Han Sans;
        font-size: 16px;
        font-weight: 350;
        line-height: 26px;
        text-align: center;
        letter-spacing: normal;
        color: #666666;
      }
    }
  }
  .fourBox{
    text-align: center;
    .jtImg{
      position: relative;
      width: 480px;
      z-index: 999;
    }
    .content{
      padding: 25px 58px 14px 57px;
      border-radius: 10px;
      background: #FFFFFF;
      transform: translatey(-30px);
      display: flex;
      justify-content: space-between;
      align-items: center;
      text-align: left;
      .left{
        .title{
          font-family: Source Han Sans;
          font-size: 30px;
          font-weight: bold;
          line-height: 34px;
          letter-spacing: normal;
          color: #222222;
        }
        .text{
          font-family: Source Han Sans;
          font-size: 20px;
          font-weight: 350;
          line-height: 34px;
          letter-spacing: normal;
          color: #666666;
          margin-top: 16px;
        }
      }
      .right{
        text-align: center;
        img{
          width: 130px;
          height: 130px;
          border-radius: 10px;
        }
        p{
          font-family: Source Han Sans;
          font-size: 16px;
          font-weight: 350;
          line-height: 34px;
          text-align: center;
          letter-spacing: normal;
          color: #222222;
          margin-top: 7px;
        }
      }
    }
  }
}
.threeCon{
  background: #F9FAFB;
  padding: 77.5px 0px 10px 0px;
  .widthCon{
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 1200px;
    margin: 0 auto;
  }
  .left{
    .title{
      font-family: Source Han Sans;
      font-size: 30px;
      font-weight: bold;
      line-height: 48px;
      letter-spacing: normal;
      color: #222222;
    }
    .content{
      width: 900px;
      height: 100px;
      font-family: Source Han Sans;
      font-size: 20px;
      font-weight: 350;
      line-height: 34px;
      letter-spacing: normal;
      color: #666666;
      text-indent: 2em;
text-align: justify;
      margin-top: 15px;
    }
  }
  .right{
    position: relative;
    .detailBtn{
      cursor: pointer;
      border-radius: 6px;
      background: #4A90E2;
      font-family: Source Han Sans;
      font-size: 16px;
      font-weight: 500;
      line-height: 34px;
      letter-spacing: 0.2em;
      font-variation-settings: "opsz" auto;
      color: #FFFFFF;
      width: 214px;
      height: 50px;
      margin-top: 18px;
      display: flex;
      justify-content: center;
      align-items: center;
      img{
        margin-left: 14px;
        width: 18px;
        height: 18px;
      }
    }
    .tip{
      position: absolute;
      width: 151px;
      height: 36px;
      font-family: Source Han Sans;
      font-size: 16px;
      font-weight: 350;
      color: #FF6F61;
      top: -22px;
      left: calc(50% - 75px);
      text-align: center;
      img{
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
      }
      span{
        display: inline-block;
        transform: translatey(3px);
      }
    }
  }
}
.fourCon{
  text-align: center;
  padding-bottom: 57.5px;
  padding-top: 55.5px;

}
.fiveCon{
  padding: 79px 0px 40px 0px;
  background: #F9FAFB;
  .widthCon{
    width: 1200px;
    margin: 0 auto;
  }
  .title{
    font-family: Source Han Sans;
    font-size: 30px;
    font-weight: bold;
    line-height: 48px;
    letter-spacing: normal;
    color: #222222;
    margin-bottom: 28px;
  }
  .content{
    .el-col{
      margin-bottom: 40px;
      .list{
        border-radius: 10px;
        background: #FFFFFF;
        padding: 35px 44px 26px 44px;
        text-align: center;
        .col_title{
          margin-bottom: 21px;
          div{
            position: relative;
            font-family: Source Han Sans;
            font-size: 20px;
            font-weight: bold;
            line-height: 26px;
            text-align: center;
            letter-spacing: normal;
            color: #222222;
            display: inline-block;
            img{
              width: 47.5px;
              height: 47.5px;
              position: absolute;
              left: -23px;
              top: -12px;
            }
          }
        }
        .col_content{
          font-family: Source Han Sans;
          font-size: 20px;
          font-weight: 350;
          line-height: 34px;
          text-align: center;
          letter-spacing: normal;
          color: #666666;
          height: 101px;
        }
      }
    }
  }
}
</style>